/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Collapseuploadpanel4Inputs */

const en_coinvestments_dataroom_collapseuploadpanel4 = /** @type {(inputs: Coinvestments_Dataroom_Collapseuploadpanel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse upload details`)
};

/**
* | output |
* | --- |
* | "Collapse upload details" |
*
* @param {Coinvestments_Dataroom_Collapseuploadpanel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_collapseuploadpanel4 = /** @type {((inputs?: Coinvestments_Dataroom_Collapseuploadpanel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Collapseuploadpanel4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_collapseuploadpanel4(inputs)
});
export { coinvestments_dataroom_collapseuploadpanel4 as "coInvestments_dataRoom_collapseUploadPanel" }